<template>
  <TableComp
    :headers="headers"
    :name="$t('global.blacklisted-ips')"
    :status="status"
    :number-of-items="getList().length"
    empty-image="magento-blacklisted-ips"
    :empty-bold-message="$t('global.all-clear')"
    :empty-message="$t('global.no-blacklisted-ips-message')"
  >
    <template #content>
      <p>{{ $t("global.blacklisted-ips-description") }}</p>
    </template>
    <template v-slot:desktop>
      <TableRow v-for="item in getList()" :key="item.id">
        <td class="align-middle">{{ item.ipAddress }}</td>
        <td class="align-middle text-center">{{ item.location }}</td>
        <td class="align-middle text-center">{{ getDate(item) }}</td>
      </TableRow>
    </template>
    <template v-slot:mobile>
      <TableMobileRow v-for="item in getList()" :key="item.id">
        <template v-slot:header>
          {{ item.ipAddress }}
        </template>
        <template v-slot:content>
          <div class="row">
            <div class="col">{{ $t("global.location") }}:</div>
            <div class="col break-word">{{ item.location }}</div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.date") }}:</div>
            <div class="col">{{ getDate(item) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { dateFormat } from "leatherman-js/utils/formatters/time";
import { reactive } from "@vue/composition-api";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";

export default {
  name: "MagentoBlacklistTable",
  props: {
    blacklist: {
      type: Array,
      default: () => [],
    },
    status: {
      type: Object,
      require: true,
    },
  },
  components: {
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const selected = reactive({ checkbox: {} });
    const headers = [
      new TableHeader(root.$t("global.ip-address"), undefined),
      new TableHeader(root.$t("global.location"), "justify-content-center"),
      new TableHeader(root.$t("global.date"), "justify-content-center"),
      new TableHeader(),
    ];

    const getDate = (item) => dateFormat(item.date);

    const getList = () => props.blacklist || [];

    return {
      getDate,
      getList,
      headers,
      selected,
    };
  },
};
</script>
